"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLoading = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _Elements = require("./Elements");

var _loading = _interopRequireDefault(require("../../assets/icons/loading.svg"));

var Loading = function Loading(_ref) {
  var visible = _ref.visible;
  return /*#__PURE__*/_react["default"].createElement(_Elements.StyledLoader, {
    visible: visible
  }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    cacheRequests: true,
    className: "close",
    src: _loading["default"],
    uniquifyIDs: true
  }));
};

Loading.defaultProps = {
  visible: true
};
Loading.propTypes = {
  visible: _propTypes["default"].bool
};
var _default = Loading; // Higher Order Component which renders a <Loading /> component if the
// given assertion function returns false

exports["default"] = _default;

var withLoading = function withLoading(assertion) {
  return function (C) {
    return function (props) {
      return assertion(props) ? /*#__PURE__*/_react["default"].createElement(C, props) : /*#__PURE__*/_react["default"].createElement(Loading, null);
    };
  };
};

exports.withLoading = withLoading;